export default "__VITE_ASSET__BFlrXSx6__"